<script lang="ts">
  import {
    menuDrawerOpen,
    menu,
    activeSection,
    keyboardMode,
    colors,
    focusContent,
    scrollDisabled,
    activeColor,
  } from "$lib/data";
  import { page } from "$app/stores";
  import { fade, fly, slide } from "svelte/transition";
  import Logo from "$lib/components/layout/header/Logo.svelte";
  import PopOut from "./icons/PopOut.svelte";

  let height: number;

  let details: boolean = true;

  // keyboard navigation control
  let logoLink: HTMLElement;
  import { onMount } from "svelte";
  import { browser } from "$app/environment";
  import Avatar from "$components/profile/Avatar.svelte";
  import DisplayName from "$components/profile/DisplayName.svelte";

  const endMenu = () => {
    if (!browser) return;
    $menuDrawerOpen = false;
    $focusContent = true;
    setTimeout(() => {
      $focusContent = false;
    }, 1000);
  };

  onMount(() => {
    if ($menuDrawerOpen && $keyboardMode) {
      logoLink.focus();
    }
  });
</script>

<svelte:window bind:innerHeight={height} />
<div
  class="mobileMenu"
  on:click={() => ($menuDrawerOpen = false)}
  on:click={() => ($scrollDisabled = false)}
  on:keypress={() => ($menuDrawerOpen = false)}
  on:keypress={() => ($scrollDisabled = false)}
  in:fade={{ duration: 200 }}
  out:fade={{ duration: 200 }}
  role="button"
  aria-pressed="false"
  tabindex="-1"
>
  <nav
    in:fly={{ duration: 400, x: 200 }}
    out:fly={{ duration: 400, x: 200 }}
    style:height={height + "px"}
  >
    <header class:noKeys={!$keyboardMode}>
      <div>
        <button
          on:click={() => ($menuDrawerOpen = false)}
          aria-label="Close navigation menu"
        >
          <svg
            fill="none"
            viewBox="0 0 24 24"
            height="24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
            />
          </svg>
        </button>
        <button
          on:click|stopPropagation={() => (details = !details)}
          aria-label="Toggle link details"
        >
          {#if details}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
              ><rect width="256" height="256" fill="none" /><line
                x1="216"
                y1="128"
                x2="40"
                y2="128"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><line
                x1="128"
                y1="16"
                x2="128"
                y2="96"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><polyline
                points="160 64 128 96 96 64"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><line
                x1="128"
                y1="240"
                x2="128"
                y2="160"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><polyline
                points="96 192 128 160 160 192"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /></svg
            >
          {:else}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
              ><rect width="256" height="256" fill="none" /><line
                x1="216"
                y1="128"
                x2="40"
                y2="128"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><line
                x1="128"
                y1="96"
                x2="128"
                y2="16"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><polyline
                points="96 48 128 16 160 48"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><line
                x1="128"
                y1="160"
                x2="128"
                y2="240"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /><polyline
                points="160 208 128 240 96 208"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              /></svg
            >
          {/if}
        </button>
      </div>
      {#if $page.data.user}
        <div class="user">
          <a href="/members">
            <span class="user_title">
              <DisplayName user={$page.data.user} />
            </span>
            <div class="avatar">
              <Avatar user={$page.data.user} />
            </div>
          </a>
        </div>
      {:else}
        <a
          rel="external"
          on:click={() => {
            $menuDrawerOpen = false;
          }}
          href="/login"
          class="login_button"
          style="
                            --primary: {colors[$activeColor].color};
                            --secondary: {colors[$activeColor].highlight};
                        "
        >
          Member Login
        </a>
      {/if}
    </header>

    {#if $keyboardMode}
      <a href="/" class="logo" bind:this={logoLink}>
        <Logo />
      </a>
    {/if}
    {#each menu as item, index}
      {@const subMenu =
        (menu[index].loggedInSub ?? []).length > 0 && $page.data.user
          ? menu[index].loggedInSub
          : menu[index].sub}
      <div
        style="
                --primary: {colors[index].color};
                --secondary: {colors[index].highlight};
            "
      >
        <h2>
          {$page.data.user && item.loggedInText ? item.loggedInText : item.text}
        </h2>
        <ul>
          {#each subMenu as item, sub_index}
            <li
              class:active={$page.url.pathname === item.href &&
                (item.sub ?? []).length === 0}
              class:has_sub={(item.sub ?? []).length > 0}
            >
              <a
                href={$page.data.user && item.loggedInHref
                  ? item.loggedInHref
                  : item.href}
                on:click={() => ($activeSection = menu[index].section)}
                tabindex="0"
                rel={item.external ? "external" : ""}
              >
                <div class="icon" class:center={!details}>
                  {#if (item.sub ?? []).length === 0 || item.override_arrows}
                    <svelte:component
                      this={item.loggedInComponent && $page.data.user
                        ? item.loggedInComponent
                        : item.component}
                      size={22}
                      color={$page.url.pathname === item.href
                        ? "var(--secondary)"
                        : item.hover
                          ? "var(--primary)"
                          : "#999"}
                    />
                  {:else}
                    <PopOut
                      size={26}
                      color={$page.url.pathname === item.href
                        ? "var(--secondary)"
                        : item.hover
                          ? "var(--primary)"
                          : "#999"}
                    />
                  {/if}
                </div>
                <div class="stack">
                  <div class="title">
                    {#if item.loggedInText && $page.data.user}
                      {item.loggedInText}
                    {:else}
                      {item.text}
                    {/if}
                  </div>
                  {#if details}
                    <div class="subTitle" transition:slide={{ duration: 150 }}>
                      {#if item.loggedInTitle && $page.data.user}
                        {item.loggedInTitle}
                      {:else}
                        {item.title}
                      {/if}
                    </div>
                  {/if}
                </div>
              </a>

              {#if (item.sub ?? []).length > 0}
                <ul
                  class:locked={sub_index === 0 &&
                    !$page.data.user &&
                    index === 3}
                >
                  {#each item.sub ?? [] as sub}
                    <li class:active={$page.url.pathname === sub.href}>
                      <a
                        href={sub.href}
                        on:click={() => ($activeSection = menu[index].section)}
                        tabindex="0"
                        rel={sub.external ? "external" : ""}
                        class:auth_required={sub.auth_required &&
                          !$page.data.user}
                        class:super={sub.superhighlight && !$page.data.user}
                      >
                        <div class="icon" class:center={!details}>
                          <!-- svelte-ignore missing-declaration -->
                          <svelte:component
                            this={sub.loggedInComponent && $page.data.user
                              ? sub.loggedInComponent
                              : sub.component}
                            size="20"
                            color="{sub.superhighlight && !$page.data.user
                              ? 'white'
                              : $page.url.pathname === sub.href
                                ? 'var(--secondary)'
                                : sub.hover
                                  ? 'var(--primary)'
                                  : '#999'}
                                                        "
                          />
                        </div>
                        <div class="stack">
                          <div class="title">
                            {#if sub.loggedInText && $page.data.user}
                              {sub.loggedInText}
                            {:else}
                              {sub.text}
                            {/if}
                          </div>
                          {#if details}
                            <div
                              class="subTitle"
                              transition:slide={{
                                duration: 150,
                              }}
                            >
                              {#if sub.loggedInTitle && $page.data.user}
                                {sub.loggedInTitle}
                              {:else}
                                {sub.title}
                              {/if}
                            </div>
                          {/if}
                        </div>
                      </a>
                    </li>
                  {/each}
                </ul>
              {/if}
            </li>
          {/each}
        </ul>
      </div>
    {/each}

    {#if $keyboardMode}
      <a
        style:text-decoration="none"
        style:font-weight="normal"
        href="/"
        on:click|preventDefault={endMenu}
        on:focus={endMenu}
      >
        <small>
          <kbd>CTRL</kbd> + <kbd>M</kbd> MENU TOGGLE
        </small>
        <small>
          <kbd>CTRL</kbd> + <kbd>,</kbd> FOCUS CONTENT
        </small>
      </a>
    {/if}
  </nav>
</div>

<style>
.user_title {
  color: var(--title);
  padding-left: 1rem;
  display: inline-flex;
  gap: 0.15rem;
}

.login_button {
  margin-left: 1.5rem;
  text-decoration: none;
  font-size: 1rem;
  color: white;
  background: var(--secondary);
  display: inline-flex;
  padding: 0.6rem 1.1rem;
  border-radius: 0.7rem;
  position: relative;
  overflow: hidden;
}
.login_button:hover {
  background: var(--primary);
}

.mobileMenu {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  color: white;
  background: hsla(207, 18%, 15%, 0.95);
  box-sizing: border-box;
}
.mobileMenu .logo {
  margin: 1rem;
  display: flex;
  align-items: center;
  font-family: Bitter;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.7rem;
}
.mobileMenu header {
  border-bottom: 1px solid var(--dots);
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: white;
}
.mobileMenu header .user a {
  align-items: center;
  gap: 0.5rem;
  display: flex;
  text-decoration: none;
  font-size: 0.75rem;
}
.mobileMenu header .user a .avatar {
  width: 40px;
  height: 40px;
}
.mobileMenu header button {
  border: none;
  display: inline-grid;
  place-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--dots);
  background: white;
  border-radius: 0.25rem;
}
.mobileMenu header button svg {
  width: 24px;
  height: 24px;
  color: var(--title);
}
.mobileMenu header button svg path {
  fill: var(--title);
}
.mobileMenu header.noKeys {
  margin-bottom: 1rem;
}
.mobileMenu nav {
  background: white;
  position: absolute;
  right: 0;
  height: 100vh;
  overflow-y: auto;
  width: 370px;
  max-width: 100%;
  box-shadow: var(--shadow);
}
.mobileMenu nav > div {
  border-bottom: 1px solid var(--dots);
  margin-bottom: 1rem;
}
.mobileMenu nav > div:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
}
.mobileMenu nav small {
  color: #666;
  padding: 1rem;
  display: block;
  line-height: 1.5;
  font-size: 0.9rem;
  border-top: 1px solid var(--dots);
}
.mobileMenu nav small kbd {
  margin: 0px 0.1em;
  padding: 0.1em 0.6em;
  border-radius: 3px;
  border: 1px solid rgb(204, 204, 204);
  color: rgb(51, 51, 51);
  line-height: 1.4;
  font-family: Bitter;
  font-size: 1rem;
  display: inline-block;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.2), inset 0px 0px 0px 2px #ffffff;
  background-color: rgb(247, 247, 247);
  -moz-box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2), 0 0 0 2px #ffffff inset;
  -webkit-box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2), 0 0 0 2px #ffffff inset;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  text-shadow: 0 1px 0 #fff;
}
.mobileMenu nav h2 {
  font-size: 1.2rem;
  margin: 0;
  padding-left: 1rem;
  color: var(--primary);
}
.mobileMenu nav ul {
  list-style: none;
  padding: 0.5rem 1rem 1rem 1rem;
  margin: 0;
  font-size: 1rem;
}
.mobileMenu nav ul > li.has_sub a {
  padding: 0.4rem 0.4rem 0 0.4rem;
}
.mobileMenu nav ul > li.active {
  background: #f1f5f7;
  border-radius: 0.5rem;
}
.mobileMenu nav ul > li.active.has_sub {
  background: transparent;
  border: 1px solid var(--dots);
}
.mobileMenu nav ul > li a {
  text-decoration: none;
  color: var(--title);
  display: flex;
  flex-flow: row;
  padding: 0.4rem;
}
.mobileMenu nav ul > li a .icon {
  width: 25px;
  padding-top: 3px;
}
.mobileMenu nav ul > li a .icon.center {
  padding-top: 0;
  display: grid;
  place-content: center;
}
.mobileMenu nav ul > li a .stack {
  padding-left: 1rem;
}
.mobileMenu nav ul > li a .stack .title {
  padding-top: 0.2rem;
  font-weight: bold;
  display: flex;
  align-content: center;
}
.mobileMenu nav ul > li a .stack .subTitle {
  font-size: 0.8rem;
  line-height: 1.3;
  font-weight: normal;
  font-family: "Open Sans", sans-serif;
  color: #999;
  padding-top: 0.2rem;
}
.mobileMenu nav ul > li ul {
  padding: 0.5rem 0 0.75rem 2rem;
}
.mobileMenu nav ul > li ul li {
  color: var(--title);
  font-size: 90%;
  padding: 0 0.5rem 0.5rem 0.5rem;
}
.mobileMenu nav ul > li ul li a .icon {
  width: 20px;
}

.locked {
  background-color: #ffffff;
  border-radius: 1rem;
  margin-top: 0.5rem !important;
  padding-top: 1rem !important;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23e8ebf3' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E") !important;
}

.super {
  background: var(--secondary);
  border-radius: 0.75rem;
  padding: 0.5rem !important;
  position: relative;
  z-index: 14 !important;
  overflow: hidden;
}
.super .title {
  border-bottom: rgba(255, 255, 255, 0.4);
  color: white;
}
.super .subTitle {
  font-weight: bold;
  color: white !important;
}
</style>
